import * as React from 'react';
import { ArticleHeading1, ArticleParagraph1, Button } from '@cian/ui-kit';
import * as styles from './styles.css';

import img from './assets/pic1.svg';

interface ICandidateModalProps {
  isPhone: boolean;
  onClick: () => void;
}

export const CandidateModal: React.FC<ICandidateModalProps> = ({ isPhone, onClick }) => {
  return (
    <div className={styles['container']}>
      <div>
        <img src={img} alt="" />
      </div>

      <div className={styles['content']}>
        <ArticleHeading1>Только 10% кандидатов попадают в команду</ArticleHeading1>

        <ArticleParagraph1>
          Профессионализм и большой опыт в сфере недвижимости — это базовый минимум.
        </ArticleParagraph1>
        <ArticleParagraph1>
          Мы проверяем, что риелторы могут уверенно вести сделки разной сложности, могут разобраться в юридических
          нюансах и способны эффективно взаимодействовать со всеми инстанциями и службами.
        </ArticleParagraph1>
        <ArticleParagraph1>
          Учитываем не только рабочие показатели, но и человеческие качества: даже самые профессиональные и опытные
          агенты не попадут к нам, если они не умеют вежливо общаться с клиентами.
        </ArticleParagraph1>

        <div className={styles['button']}>
          <Button fullWidth={isPhone} onClick={onClick}>
            Строгий отбор!
          </Button>
        </div>
      </div>
    </div>
  );
};
